import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";
import router from "@/router";

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
   // Vue.axios.defaults.baseURL = "https://api.ims.directory/api/v1/";
     Vue.axios.defaults.baseURL = "https://api.moonadmin.influencer.ae/";
     ApiService.setHeader();
    ApiService.addInterceptors();
    
  },

  /**
   * Set the default HTTP request headers
   */
  // setHeader() {
  //   Vue.axios.defaults.headers.common[
  //     "Authorization"
  //   ] = `Token ${JwtService.getToken()}`;
  // },
 /**
   * Set the default HTTP request headers
   */
 setHeader() {
  Vue.axios.defaults.headers.common["Authorization"] =
    "Bearer 235da65e7efe666dbc2c520121bd9aa881fb841f5f51c83bb6b16656ff2edb83";
},

  // setHeader() {
  //   },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource) {
    return Vue.axios.get(`${resource}`).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
  addInterceptors() {
    Vue.axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          localStorage.clear();
          JwtService.destroyToken();
          router.push({ name: 'login' });
        }
        return Promise.reject(error);
      }
    );
  }
};


export default ApiService;
